import { render, staticRenderFns } from "./FFormDrawer.vue?vue&type=template&id=7481ffca&scoped=true&"
import script from "./FFormDrawer.vue?vue&type=script&lang=ts&"
export * from "./FFormDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./FFormDrawer.vue?vue&type=style&index=0&id=7481ffca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7481ffca",
  null
  
)

export default component.exports